<p-toast />
<p-confirmPopup />

<div>
    <ul class="layout-menu">
        <div style="padding-bottom: 20px;">
            <ng-container *ngFor="let item of model; let i = index;">
                <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
                <li *ngIf="item.separator" class="menu-separator"></li>
            </ng-container>
        </div>
        <hr>
        <div style="padding-top: 15px;">
            <li>
                <button  pButton  (click)="confirmLogout($event)" class="full-width-button"  severity="danger" >
                    <i class="pi pi-sign-out"></i> Cerrar Sesión
                </button>
            </li>
        </div>
    </ul>
</div>
